<template>
  <div class="add-expert">
    <p style="font-size: 16px; background-color: #fff;padding: 10px;">问卷调查</p>

    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="title">
          <span style="color: red;" v-if="item.isRequired == 1">*</span>
          {{ index + 1 }}、{{ item.problem }}
        </div>
        <div class="opetions" v-if="item.type == 1 || item.type == 2" v-for="(subItem, subIndex) in item.qaList"
          :key="subIndex">
          <img class="img-icon" @click="handleSelOption(index, subIndex)"
            v-if="(item.optionIds || []).indexOf(subItem.id) == -1" src="../../assets/images/login/unchecked-ico.png" />
          <img class="img-icon" @click="handleSelOption(index, subIndex)" v-else
            src="../../assets/images/login/checked-ico.png" />
          <div>{{ subItem.content }}</div>
        </div>
        <div class="inputCon" v-if="item.type == 3">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="item.optionContent" placeholder="请输入" />
        </div>

        <!-- 文件 -->
        <div class="file" v-if="item.type == 4">
          <van-uploader v-model="item.fileUrls" :max-count="6" :after-read="(file) => uploadFile(file, index)"
            :before-read="beforeRead" @oversize="onOversize" @delete="onDelete" />
        </div>
      </div>
    </div>







    <div class="create">
      <van-button size="large" @click="commitInfo" color="linear-gradient(to right, #5DD682, #5AFF8E)">提交</van-button>
    </div>


  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
import {
  updateQuestion,
  getQuestion,
} from "@/utils/api/question";

import { Dialog } from 'vant';

import { uploadImg } from "@/utils/api/user";
import { checkUploadFile } from "@/utils/tool";
import { uploadFile } from "@/utils/api/user";

import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
export default {
  mixins: [validate],
  components: {
    Crop
    // SignTitle
  },
  data() {
    return {
      list: [],
      showTypeId: false,
      showTypeSub: false,
      type: '',
      typeSub: '',
      sendClip: true,
      second: 60,
      formData: {
        name: '',
        tel: '',
        code: '',
        password: '',
        contactAddress: '',
        contactArea: '',
        contactCity: '',
        contactProvince: '',
        logo: '',
        credentialsImg: '',
        synopsis: '',
        personCharge: '',
        contactsTel: '',
        contactEmail: '',
        wxAccounts: '',
        inviteCode: '',
        license: '',
        zoneId: '',
      },


      inviteStatus: 0,

      // 省市区
      city: "",
      // 区域树
      areaList,
      // 显示区域选择
      showArea: false,
      // 头像
      logo: [],
      credentialsImg: [],
      // 专业列表
      // 活动列表
      // 性别
      // 显示选择框
      // 所选专业
      // 所选专业
      // 所选活动
      // 所选活动
      // 显示选择
      // 显示活动选择
      // 标签
      mode: 0, // 0新增，1修改
      compressShowlogo: false,
      compressShowcredentialsImg: false,
      compressImglogo: "",
      compressImgcredentialsImg: "",

    };
  },
  mounted() {
    this.validate.setFormDataKey("formData");
    this.formData.id = this.$route.query.id
    this.getList();
  },
  methods: {

    beforeRead(file) {
      // if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      //   Toast('请上传 jpg 或 png 格式图片');
      //   return false;
      // }
      return true;
    },
    onOversize(file) {
      // Toast('文件大小不能超过 500KB');
    },
    uploadFile(file, index) {
      // 这里实现上传逻辑

      const formData = new FormData();
      formData.append('file', file.file);

      uploadImg(formData).then(({ success, data }) => {
        if (success) {
          console.log('success == ', data)
          console.log('list == ', this.list)
          var item = this.list[index]
          console.log(item)
          var last = item.fileUrls[item.fileUrls.length - 1]
          last.url = data
          console.log('list == ', this.list)

          this.$forceUpdate();
          return success;
        } else {
          console.log('fail == ', data)

          this.$forceUpdate();
          return false;
        }
      });

    },
    onDelete(file) {
      // Toast('删除文件');
    },

    // 获取列表
    getList() {
      getQuestion({
        id: this.formData.id
      }).then(res => {
        if (res.code == 20000) {

          var data = res.data || []
          data.forEach(element => {
            element.optionIds = []
            element.optionContents = []
            element.fileUrls = []
          });
          this.list = data
        }
      })
    },
    // 选择选项
    handleSelOption(index, subIndex) {
      var item = this.list[index]
      var option = item.qaList[subIndex]

      console.log(item, option)
      if (item.type == 1) {
        // 单选
        item.optionIds = [option.id]
        item.optionContents = [option.content]
        return
      }

      if (item.type == 2) {
        // 多选
        var optionIds = item.optionIds;
        var optionContents = item.optionContents;
        var selIndex = optionIds.indexOf(option.id)
        if (selIndex == -1) {
          optionIds.push(option.id)
          optionContents.push(option.content)
        } else {
          optionIds.splice(selIndex, 1)
          optionContents.splice(selIndex, 1)
        }

        console.log(this.list[index])
        return
      }

    },


    commitInfo() {
      console.log(this.list)

      var results = []
      var isgo = true
      this.list.forEach(item => {
        if (item.type == 3) {
          item.optionContents = [item.optionContent]
        }
        var files = []
        if (item.type == 4) {
          item.fileUrls.forEach(file => {

            console.log('file == ', file)
            files.push(file.url)
          })
        }

        item.files = files


        if (item.isRequired == 1 && item.fileUrls.length == 0 && item.optionContents.length == 0) {
          this.$root.$toast.fail(`请完成必填项`)
          isgo = false
          return
        }

        results.push({
          surveyId: this.formData.id,
          status: item.status,
          problemId: item.id,
          problemContent: item.problem,
          optionId: item.optionIds,
          optionContent: item.optionContents,
          fileUrls: item.files
        })


      })

      if (isgo == false) {
        return
      }




      // if (!this.formData.contactEmail) {
      //   this.$root.$toast.fail("请填写联系人邮箱");
      //   return;
      // }


      updateQuestion(results).then(res => {
        console.log(res)
        if (res.success) {
          this.$root.$toast.success('提交成功,感谢您的反馈');
        }
      })
    },



  },

};
</script>

<style lang="scss" scoped>
.add-expert {
  overflow: hidden;
  background-color: #fff;
  min-height: 100vh;


  .create {
    margin: 0 auto;
    width: 254px;
    margin-top: 40px;
    margin-bottom: 60px;
    background-color: #fff;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }

  .list {
    background-color: #fff;

    .item {
      padding: 15px;
      border-bottom: 0.5px solid #eee;

      .title {
        font-weight: bold;
        font-size: 16px;
        color: #333;
      }

      .opetions {
        display: flex;
        margin-top: 10px;
        font-size: 14px;

        .img-icon {
          margin-right: 5px;
          margin-top: 2px;
          width: 15px;
          height: 15px;
        }
      }

      .inputCon {
        margin-top: 10px;

        .el-input {
          background-color: #eee;
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.add-expert {
  text-align: left;

  .van-cell {
    &::after {
      border: none;
    }
  }

  .van-uploader {
    @include from-upload-style;
  }

  .custom-title {
    color: #646566;
  }

  .custom-tit {
    font-size: 12px;
    color: #ccc;
  }

  .expert-userImg {
    text-align: left;
    padding-top: 10px;
    padding-left: 10px;
    background: #fff;
  }

  .custom-span {
    color: #ccc;
  }

  .affixs-label {
    width: unset;

    &+.van-field__value {
      display: none;
    }
  }
}
</style>
